export default "__VITE_ASSET__DZdx7oDg__"